<template>
  <div>
    <section class="content">
      <div class="row">
        <div class="col-md-3">

          <!-- Profile Image -->
          <div class="box box-primary">
            <div class="box-body box-profile" v-if="memberloanplan.member">

              <ul class="list-group list-group-unbordered">
                <li class="list-group-item">
                  <b>Name</b> <a class="pull-right">{{memberloanplan.member.name}}</a>
                </li>
                <li class="list-group-item">
                  <b>Code</b> <a class="pull-right">{{memberloanplan.member.code}}</a>
                </li>
                <li class="list-group-item">
                  <b>Loan Application No</b> <a class="pull-right">{{memberloanplan.applicationNo}}</a>
                </li>
                <li class="list-group-item">
                  <b>Mobile</b> <a class="pull-right">{{memberloanplan.member.mobile}}</a>
                </li>
                <li class="list-group-item" v-if="memberloanplan.collection_center">
                  <b>Group</b> <a class="pull-right">{{memberloanplan.collection_center.name}}</a>
                </li>
                <li class="list-group-item">
                  <b>Loan Status</b> <a class="pull-right">{{memberloanplan.status}}</a>
                </li>
              </ul>

              <a href="#" class="btn btn-primary btn-block"><b>View Profile</b></a>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->

          <!-- About Me Box -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Other Details</h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <strong><i class="fa fa-info margin-r-5"></i> Description</strong>

              <p class="text-muted" v-if="memberloanplan.disbursement">
                {{memberloanplan.disbursement.description}}
              </p>

              <hr>
              <strong><i class="fa fa-money margin-r-5"></i> Total Amount</strong>

              <p class="text-muted">
                <strong>₹</strong>{{memberloanplan.totalAmt}}/-
              </p>

              <hr>

              <strong><i class="fa fa-money margin-r-5"></i> Received Amount</strong>

              <p class="text-muted"><strong>₹</strong>{{memberloanplan.receivedAmt}}/-</p>
              <span v-if="memberloanplan.receivedPrincipal">
                <hr>
                <strong><i class="fa fa-money margin-r-5"></i> Received Principal Amount</strong>
                <p class="text-muted"><strong>₹</strong>{{memberloanplan.receivedPrincipal}}/-</p>
              </span>
              <span v-if="memberloanplan.status !== 'sattlement'">
                <hr>
                <strong><i class="fa fa-money margin-r-5"></i> Due Amount</strong>

                <p class="text-muted" v-if="memberloanplan.disbursement"><i v-if="memberloanplan.disbursement.planCategory === 'interest'"><strong>₹</strong>{{memberloanplan.totalAmt - memberloanplan.receivedPrincipal}}/-</i><i v-else><strong>₹</strong>{{memberloanplan.totalAmt - memberloanplan.receivedAmt}}/-</i></p>
              </span>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
        <!-- /.col -->
        <div class="col-md-9">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="active"><a href="#paymentrecord" data-toggle="tab">PAYMENT RECORD</a></li>
              <li><a href="#emirecord" data-toggle="tab">EMI RECORD</a></li>
              <!-- <li v-if="memberloanplan.status !== 'sattlement'"><a href="#due" data-toggle="tab" @click="getCurrentDue">DUE</a></li>
              <li v-if="memberloanplan.status !== 'sattlement'"><a href="#advanceamount" data-toggle="tab" @click="getCurrentDue">ADVANCE PAYMENT</a></li>
              <li v-if="memberloanplan.status !== 'sattlement'"><a href="#settlement" data-toggle="tab" @click="getCurrentDue">SETTLEMENT</a></li> -->
            </ul>
            <div class="tab-content">
              <div class="active tab-pane" id="paymentrecord">
                <div class="timeline-body">
                  <div class="card-body table-sm">
                    <div class="row">
                      <div class="col-sm-6 col-xs-6">
                        <label>
                          Amount : <strong>₹</strong>{{memberloanplan.receivedAmt}}/-
                        </label>
                      </div>
                      <div class="col-sm-6 col-xs-6">
                        <div class="input-group pull-right input-group-sm" style="width: 150px;">
                          <input type="text" v-model="table_search" @keyup.enter="getMemberLoanCollection()" name="table_search" class="form-control pull-right" placeholder="Search">

                          <div class="input-group-btn">
                            <button type="button" @click="getMemberLoanCollection()" class="btn btn-default"><i class="fa fa-search"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <table class="table table-sm table-bordered table-hover">
                      <thead style="background-color: #d6dddd;">
                        <tr>
                          <th class="hidden-xs">Sr.</th>
                          <th class="hidden-xs">Type</th>
                          <th>Pay Date</th>
                          <th>Amount</th>
                          <th class="hidden-xs">Received By</th>
                          <th>Mode</th>
                          <th class="hidden-xs">Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in rowsMemberCollections" :key="index">
                          <td class="hidden-xs">{{ (index + 1) }}</td>
                          <td class="hidden-xs"><i v-if="row.type === 'panulty'">penalty</i><i v-else>{{ row.type }}</i></td>
                          <td>{{ row.paymentDate | myDate}}</td>
                          <td><strong>₹</strong>{{ row.amt }}/-</td>
                          <td class="hidden-xs"><span v-if="row.received_by">{{ row.received_by.name }}</span></td>
                          <td><span v-if="row.branch_ledger">{{ row.branch_ledger.ledger.name }}</span></td>
                          <td class="hidden-xs"><span
                                v-if="row.status == 'pending'"
                                ><i class="fa fa-exclamation-circle fa-2x text-danger" aria-hidden="true"></i></span
                              >
                              <span
                                v-if="row.status == 'paid'"
                                class="label label-success"
                                >Paid</span
                              >
                              <span
                                v-if="row.status == 'approved'"
                                ><i class="fa fa-check-circle fa-2x text-success" aria-hidden="true"></i>
                                <i v-if="row.voucher.length === 0" class="fa fa-exclamation-triangle fa-2x text-danger" title="Voucher Not Found" aria-hidden="true"></i>
                                </span
                              >
                              <span
                                v-if="row.status == 'partial'"
                                class="label label-info"
                                >Partial</span
                              >                    
                          </td>
                          <td>
                            <div class="btn-group dropup">
                              <button type="button" class="btn btn-info btn-flat btn-xs dropdown-toggle" data-toggle="dropdown">
                                Task <span class="caret"></span>
                                <span class="sr-only">Toggle Dropdown</span>
                              </button>
                              <ul class="dropdown-menu dropdown-menu-right" role="menu">
                                <li v-if="row.status === 'approved' && row.voucher.length > 0 && canAccess('voucher-view')">
                                  <a @click="voucherView(row.id)">Ledger Entry<i class="fa fa-book" aria-hidden="true"></i></a>
                                </li>
                                <li><a @click="printView(row)">View <i class="fa fa-print" aria-hidden="true"></i></a></li>
                                <li v-if="canAccess('member-collection-delete')"><a @click="confirmPayment(row)">Delete <i class="fa fa-trash"></i></a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- /.tab-pane -->
              <div class="tab-pane" id="emirecord">
                <!-- The timeline -->
                
                
                <br/>
                <div class="card-body table-sm">
                  <div class="row">
                    <div class="col-sm-6 col-xs-6">
                      <button type="button" class="btn btn-xs btn-primary" @click="ViewEMIRecord">Print EMI</button>
                    </div>
                    <div class="col-sm-6 col-xs-6">
                      <div class="input-group pull-right input-group-sm">
                        <button type="button" class="btn btn-xs btn-warning pull-right" @click="confirmReAdvanceSecuritySettlement(advanceEmiSecurityRecords.id)">
                          Settle Advance Security
                        </button>
                      </div>
                      <div class="input-group pull-right input-group-sm">
                        <div v-if="memberloanplan.status === 'sattlement' || memberloanplan.status === 'complete'">
                          <button type="button" class="btn btn-xs btn-danger pull-right" @click="confirmReSettlement()">
                            Loan EMI Re-Settle
                          </button>
                        </div>
                        <div v-else>
                          <button type="button" class="btn btn-xs btn-danger pull-right" @click="confirmReSettlement()">
                            Loan EMI Re-Settle
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <table class="table table-sm table-bordered table-hover">
                    <thead style="background-color: #d6dddd;">
                      <tr>
                        <th class="hidden-xs">Sr.</th>
                        <th>EMI Dt</th>
                        <th class="hidden-xs">Principal</th>
                        <th class="hidden-xs">Interest</th>
                        <th>EMI</th>
                        <th class="hidden-xs">Adjustment</th>
                        <th class="hidden-xs">Balance</th>
                        <th>Rec. Amt</th>
                        <th>Arrear</th>
                        <th class="hidden-xs">Advance</th>
                        <th class="hidden-xs">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in rows" :key="index">
                        <td class="hidden-xs">{{ (index + 1) }}</td>
                        <td>{{ row.emiDate | myDate }}</td>
                        <td class="hidden-xs">₹{{ row.principal }}/-</td>
                        <td class="hidden-xs">₹{{ row.intrest }}/-</td>
                        <td><strong>₹</strong>{{ row.total }}/-</td>
                        <td class="hidden-xs">{{ row.adjustment }}</td>
                        <td class="hidden-xs">{{ row.balance }}</td>
                        <td>{{ row.received }}</td>
                        <td>{{ row.arrear }}</td>
                        <td class="hidden-xs">{{ row.advance }}</td>
                        <td class="hidden-xs">
                          <span
                            v-if="row.status == 'pending'"
                            class="label label-warning xs"
                          >Pending</span>
                          <span
                            v-if="row.status == 'sattle'"
                            class="label label-primary xs"
                          >Settle</span>
                          <span
                            v-if="row.status == 'lock'"
                            class="label label-primary xs"
                          >Lock</span>
                          <span
                            v-if="row.status == 'sattlement'"
                            class="label label-warning xs"
                          >Settlement</span>
                          <span
                            v-if="row.status == 'paid'"
                            class="label label-success xs"
                          >Paid</span>
                          <span
                            v-if="row.status == 'partial'"
                            class="label label-info xs"
                          >Partial</span>                    
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
              <!-- /.tab-pane -->

              <div class="tab-pane" id="due">
                <ul class="timeline timeline-inverse">
                  <!-- timeline time label -->
                  <li class="time-label">
                        <span class="bg-red">
                          Current Due
                        </span>
                  </li>
                  <!-- /.timeline-label -->
                  <!-- timeline item -->
                  <li>
                    <i class="fa fa-money bg-red"></i>

                    <div class="timeline-item">

                      <div class="timeline-body">
                        <p> <strong>Current Due Amount</strong> : {{totalCurrentDueAmt}} <i class="fa fa-inr"></i></p>
                        <emi-payment></emi-payment>
                      </div>
                      
                    </div>
                  </li>
                  <!-- END timeline item -->
                  
                  <li>
                    <i class="fa fa-window-close bg-red"></i>
                  </li>
                </ul>
              </div>
              <!-- /.tab-pane -->
              <div class="tab-pane" id="advanceamount">
                <ul class="timeline timeline-inverse">
                  <!-- timeline time label -->
                  <li class="time-label">
                        <span class="bg-red">
                          Current Due
                        </span>
                  </li>
                  <!-- /.timeline-label -->
                  <!-- timeline item -->
                  <li>
                    <i class="fa fa-money bg-red"></i>

                    <div class="timeline-item">

                      <div class="timeline-body">
                        <p> <strong>Current Due Amount</strong> : {{totalCurrentDueAmt}} <i class="fa fa-inr"></i></p>
                        <button class="btn btn-danger">Pay Now</button>
                      </div>
                      
                    </div>
                  </li>
                  <!-- END timeline item -->
                  
                  <li>
                    <i class="fa fa-window-close bg-red"></i>
                  </li>
                </ul>
              </div>
            </div>
            <!-- /.tab-content -->
          </div>
          <!-- /.nav-tabs-custom -->
        </div>
        <!-- /.col -->
        <!-- Payment Receipt Model -->
      <payreceiptview :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord"></payreceiptview>
      <printemirecords :rows="rows" :getCompanyRecord="getCompanyRecord" :logo="logo" :memberloanplan="memberloanplan" :rowsMemberCollections="rowsMemberCollections"></printemirecords>

      <!-- EMI Payment Voucher Entry Record -->
      <emivoucherentry :ventries="ventries"></emivoucherentry>
      </div>
      <!-- /.row -->
    </section>

    <!-- Paytm collection model -->
    <div class="modal fade" id="paywithpaytm">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <!-- <h4 v-show="!editMode" class="modal-title">Collection Details</h4> -->
            </div>
            <form @submit.prevent="collectPaytmPayment()">
              <div class="modal-body">
                <!-- right column -->
                <div class="col-md-12">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <input
                              type="hidden"
                              name="branch_id"
                              v-model="paytm.branch_id"
                            />
                          <input
                              type="hidden"
                              name="member_loan_plan_id"
                              v-model="paytm.id"
                            />
                          <input
                              type="hidden"
                              name="member_id"
                              v-model="paytm.member_id"
                            />
                          <input
                              type="hidden"
                              name="disbursement_id"
                              v-model="paytm.disbursement_id"
                            />
                          <input
                              type="hidden"
                              name="collection_center_id"
                              v-model="paytm.collection_center_id"
                            />
                           <div class="form-group">
                            <label>Name <span class="red">*</span></label>
                            <input
                              v-model="paytm.name"
                              type="text"
                              name="name"
                              class="form-control"
                              required
                              disabled
                            />
                            <has-error :form="form" field="name"></has-error>
                          </div>
                           <div class="form-group">
                            <label>Mobile <span class="red">*</span></label>
                            <input
                              v-model="paytm.mobile"
                              type="text"
                              name="mobile"
                              class="form-control"
                              required
                              disabled
                            />
                            <has-error :form="form" field="mobile"></has-error>
                          </div>
                           <div class="form-group">
                            <label>Email <span class="red">*</span></label>
                            <input
                              v-model="paytm.email"
                              type="text"
                              name="email"
                              class="form-control"
                              required
                              disabled
                            />
                            <has-error :form="form" field="email"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Amount <span class="red">*</span></label>
                            <input
                              v-model="paytm.amt"
                              type="text"
                              name="amt"
                              class="form-control"
                              required
                            />
                            <!-- :class="{ 'is-invalid': form.errors.has('name') }"
                            :class="{ 'is-invalid': form.errors.has('mobile') }"
                            :class="{ 'is-invalid': form.errors.has('email') }"
                            :class="{ 'is-invalid': form.errors.has('amt') }"
                            <has-error :form="form" field="amt"></has-error> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                >
                  Pay Now
                </button>
                
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
            <form id="paytmForm" method="POST" :action="`${$axios.defaults.baseURL}/paytm/payment`">
              <input v-for="(input, index) in paytm" :key="index" type="hidden" :name="index" :value="input">
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>


  </div>
</template>
<script>
import { mapState } from 'vuex'
import emivoucherentry from '../components/EmiVoucherEntry.vue'
import payreceiptview from '../components/PaymentReceipt.vue'
import printemirecords from '../components/PrintEMIRecords.vue'
import payment from './EMIPayment.vue'
export default {
  name: 'LoanDetail',
  components: {
    'EmiPayment': payment,
    emivoucherentry,
    payreceiptview,
    printemirecords
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  data () {
    return {
      userLoanId: this.$route.params.memberLoanId,
      userDisbursementId: this.$route.params.disbursmentId,
      memberloanplan: {},
      advanceEmiSecurityRecords: {},
      seeRecord: {},
      getCompanyRecord: {},
      ventries: [],
      ventry: {},
      logo: [],
      totalCurrentDueAmt: null,
      emiDate: new Date().toISOString().slice(0, 10),
      form: new Form({
        // errors: []
      }),
      table_search: '',
      paytm: {
        name: '',
        mobile: '',
        email: '',
        amt: 0,
        branch_id: '',
        member_id: '',
        disbursement_id: '',
        collection_center_id: '',
        member_loan_plan_id: '',
        receivedBy: JSON.parse(localStorage.user).id,
        mode: ''
      },
      columnsMemberCollections: [
        {
          label: 'PAYMENT DATE',
          field: 'paymentdate'
        },
        {
          label: 'AMOUNT',
          field: 'amt'
        },
        {
          label: 'TYPE',
          field: 'type'
        },
        {
          label: 'COLLECTION TYPE',
          field: 'collectionType'
        },
        {
          label: 'RECEIVED BY',
          field: 'received_by.name'
        },
        {
          label: 'PAYMENT MODE',
          field: 'branch_ledger.ledger.name'
        },
        {
          label: 'STATUS',
          field: 'Status'
        },
        {
          label: 'Actions',
          field: 'id',
          type: 'number'
        }
      ],
      rowsMemberCollections: [],
      columns: [
        {
          label: 'EMI DATE',
          field: 'emidate'
        },
        {
          label: 'PRINCIPAL',
          field: 'principal'
        },
        {
          label: 'INTEREST',
          field: 'intrest'
        },
        {
          label: 'TOTAL',
          field: 'total'
        },
        {
          label: 'ADJUSTMENT',
          field: 'adjustment'
        },
        {
          label: 'BALANCE',
          field: 'balance'
        },
        {
          label: 'RECEIVED',
          field: 'received'
        },
        {
          label: 'ARREAR',
          field: 'arrear'
        },
        {
          label: 'ADVANCE',
          field: 'advance'
        },
        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    paywithpaytm () {
      this.paytm.name = this.memberloanplan.member.name
      this.paytm.mobile = this.memberloanplan.member.mobile
      this.paytm.email = this.memberloanplan.member.email
      this.paytm.branch_id = this.memberloanplan.branch_id
      this.paytm.member_id = this.memberloanplan.member_id
      this.paytm.disbursement_id = this.memberloanplan.disbursement_id
      this.paytm.member_loan_plan_id = this.memberloanplan.id
      this.paytm.amt = 0
      this.paytm.mode = 'paytm'
      $('#paywithpaytm').modal({backdrop: 'static', keyboard: false})
    },
    collectPaytmPayment () {
      $('#paytmForm').submit()
    },
    totalCollectionSum () {
      return _.sumBy(this.rowsMemberCollections, function (o) { return o.amt })
    },
    voucherView (id) {
      this.ventries = []
      this.$axios
        .get('voucher?member_collection_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.ventries = data.data.data
          // console.log(data.data.data)
          // console.log('voucher entry')
        })
        .catch(function (error) {
          console.log(error)
        })
      $('#voucherView').modal({backdrop: 'static', keyboard: false})
    },
    confirmReSettlement () {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Re-Settle it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .post('memberemiresattlement', { 'member_loan_plan_id': this.memberloanplan.id }, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Re-Settled!', 'Your Record has been Re-Settled.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    confirmReAdvanceSecuritySettlement (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Advance EMI Security Settle it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .post('advanceemisecurity/approve/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Advance Security Settled!', 'Your Record has been Settled.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    ViewEMIRecord () {
      this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + this.userLoanId, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      $('#ViewEMIRecord').modal({backdrop: 'static', keyboard: false})
    },
    getMemberLoanCollection () {
      var pageUrl = ''
      pageUrl += 'membercollection?all=all'
      if (this.userDisbursementId) {
        pageUrl += `&disbursement_id=${this.userDisbursementId}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.rowsMemberCollections = data.data
        }).catch(function (error) { console.log(error) })
      this.$axios
      .get('memberloanplan/' + this.userLoanId, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberloanplan = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + this.userLoanId, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getCurrentDue () {
      this.totalCurrentDueAmt = 0
      if (JSON.parse(localStorage.user).type === 'admin') {
        this.$axios
        .get('adminemi?all=all&emiDate=' + this.emiDate + '&member_loan_plan_id=' + this.userLoanId, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('=========== admin wise member record =============')
          this.totalCurrentDueAmt = data.data[0]['arrear']
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      if (JSON.parse(localStorage.user).type === 'staff') {
        this.$axios
        .get('agentemi?all=all&agent_id=' + this.$store.state.user.id + '&emiDate=' + this.emiDate + '&member_loan_plan_id=' + this.userLoanId, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('=========== agent wise member record =============')
          this.totalCurrentDueAmt = data.data[0]['arrear']
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadAdvanceEmiSecurity (id) {
      this.$axios
        .get('advanceemisecurity?member_loan_plan_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.advanceEmiSecurityRecords = data.data.data[0]
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    printView (row) {
      this.seeRecord = {}
      this.seeRecord = row
      $('#payReceiptView').modal({backdrop: 'static', keyboard: false})
    }
  },
  created () {
    this.loadAdvanceEmiSecurity(this.$route.params.memberLoanId)
    this.loadCompanyProfile()
    this.getMemberLoanCollection()
    Fire.$on('AfterCreate', () => {
      this.getMemberLoanCollection()
    })
  }
}
</script>
<style scoped>
  @media print {
      div { 
        /* float: none !important; */
        /* position: static !important;  */
        display: inline; 
        /* box-sizing: content-box !important; */
      }
      .modal {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;
          padding: 0;
          overflow: visible!important;
      }
  }
  .content {
    padding: 0px;
  }
  table, tbody, tr, tr, td {
    border: 1px solid black;
  }
  p {
    font-size:18px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 10px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// LoanDetails.vue?38ca0f94